<ng-container *ngIf="matterClients$ | async as matterClients">
	<ui-content-header type="page" title="Mortgagors">
		<app-party-clients-header
			title-action
			[isClient]="true"
			[primaryContact]="!matterClients.length"
			[matterFileType]="matterFileType$ | async"
			addButtonText="Add Mortgagor to Matter"
			placeholder="Search Mortgagor"
			createButtonLabel="Create New Mortgagor"
			contactTypeLabel="Contact Type"
		></app-party-clients-header>

		<div *ngIf="isTreefortConnected" actions>
			<ui-button
				icon="puzzle"
				preset="MEDIUM_EMPHASIS"
				(click)="verify()"
				[label]="'Send IDV Request'"
			/>
			<div class="flex justify-end mt-4">
				<img
					class="h-5 w-20"
					src="/assets/images/integrations/treefort-logo.svg"
					alt="Treefort"
				/>
			</div>
		</div>
	</ui-content-header>
	<div [grid] class="@container">
		<div class="col-span-12">
			<app-acting-for-dropdown
				label="Acting for"
				[ngModel]="actingFor$ | async"
				(ngModelChange)="onActingForChange($event)"
				name="actingFor"
				[submitted]="submitted"
				*ngIf="showActingFor$ | async"
				class="inline-grid"
			></app-acting-for-dropdown>
		</div>

		<div
			class="inline-flex gap-4 flex-col @3xl:col-span-6 @6xl:col-span-5 col-span-12"
		>
			<app-client-tab
				*ngFor="let client of matterClients; trackBy: trackClient"
				[client]="client"
				[clientType]="clientTypes.BORROWER"
			></app-client-tab>
		</div>

		<div
			class="inline-flex gap-4 flex-col @3xl:col-span-6 @6xl:col-span-7 col-span-12"
		>
			<ui-section title="Mortgagor Law Firm" *ngIf="showLawFirms$ | async">
				<app-law-firms
					section-content
					class="w-full"
					label="Mortgagor Law Firm"
					[showClerk]="true"
					[fileNumber]="otherPartyFileNumber$ | async"
					[showFileNumber]="true"
					placeholder="Search Lawyer, Clerk or Law Firm"
					[lawFirm]="mortgagorLawFirm$ | async"
					(onUpdate)="onMortgagorsLawFirmUpdate($event)"
					(onUpdateFileNumber)="onFileNumberUpdated($event)"
				></app-law-firms>
			</ui-section>

			@if (isClientIntakeEnabled_()) {
				<ui-section title="Client Intake" class="[&>div]:overflow-visible">
					<ui-button
						preset="MEDIUM_EMPHASIS"
						[label]="intakeButtonText"
						(click)="sendOrViewIntake()"
						actions
					/>
					<app-client-intake-request
						section-content
					></app-client-intake-request>
				</ui-section>
			}

			<ui-section title="Details" *ngIf="showDetails$ | async">
				<div section-content class="flex flex-col gap-2">
					<app-checkbox
						type="clear"
						[ngModel]="purchaserResideInProperty$ | async"
						(ngModelChange)="setPurchasersResiding($event)"
						class="mt-2"
						>Mortgagors currently reside at subject property</app-checkbox
					>
					<app-party-capacity
						label="Capacity of ownership"
						class="mt-5 flex-1 w-full"
					></app-party-capacity>
				</div>
			</ui-section>

			<app-file-salutations></app-file-salutations>
		</div>
	</div>
</ng-container>
